import React from 'react';
import EmptyState from '@atlaskit/empty-state';
import { useIntl } from 'react-intl-next';
import messages from './messages';
import { PageNotFoundSVG } from '../assets/PageNotFoundSVG';

export const PageNotFoundEmptyState = () => {
	const { formatMessage } = useIntl();

	return (
		<EmptyState
			header={formatMessage(messages.emptyStateHeader)}
			description={formatMessage(messages.emptyStateDescription)}
			renderImage={() => <PageNotFoundSVG />}
		/>
	);
};
